import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UserGroupManagement } from "../../../model/userGroupManagement";
import { User } from "../../../model/user";
import { PermissionService } from "../../../service/permission.service";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmationDialogComponent } from "../../dialogs/confirmation-dialog/confirmation-dialog.component";
import { MoveUserDialogComponent } from "../../dialogs/move-user-dialog/move-user-dialog.component";
import { UserCompanyGroup } from "../../../model/userCompanyGroup";
import { SnackbarService } from "../../../service/snackbar.service";
import * as Sentry from "@sentry/angular";

@Component({
  selector: 'app-user-management-menu',
  templateUrl: './user-management-menu.component.html',
  styleUrls: ['./user-management-menu.component.css']
})
export class UserManagementMenuComponent implements OnInit, OnDestroy {
  @Input() groups: UserGroupManagement[];
  @Input() orphans: User[];
  @Output() onUserDisabled : EventEmitter<User> = new EventEmitter<User>();
  @Input() user: User;
  @Input() loginId: string;

  constructor(private permissionService: PermissionService,
              public dialog: MatDialog,
              private snackbarService: SnackbarService) { }

  ngOnInit(): void { }

  moveUser(): void {
    this.permissionService.getUserCompanyGroupFromUserInCompany(this.user.id, this.loginId).subscribe(res => {
      this.openMoveDialog(res);
    }, error => {
      this.snackbarService.showSnackbar("Oops, da hat etwas nicht funktioniert", false);
      console.log(error);
    });
  }

  disableUser(): void {
    this.permissionService.getUserCompanyGroupFromUserInCompany(this.user.id, this.loginId).subscribe(res => {
      res.userGroupId = null;
      this.openConfirmationDialog(res);
    })
  }

  openConfirmationDialog(userCompanyGroup: UserCompanyGroup) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: 'auto',
      data: {title: 'Nutzer sperren?', 'content': `Sind Sie sicher, dass der Nutzer ${this.user.mail} gesperrt werden soll?`}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.permissionService.moveUserToAnotherUserGroup(userCompanyGroup).toPromise().then( () => {
          const userGroupIndexOld = this.groups.findIndex(elem => elem.users.includes(this.user))
          this.groups[userGroupIndexOld].users = this.groups[userGroupIndexOld].users.filter(user => user.id !== this.user.id);
          this.onUserDisabled.emit(this.user);
        }).catch(error => {
          Sentry.captureException(error);
          console.log(error);
        });
      }
    });
  }

  openMoveDialog(userCompanyGroup: UserCompanyGroup) {
    const dialogRef = this.dialog.open(MoveUserDialogComponent, {
      width: 'auto',
      data: {user: this.user, groups: this.groups}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        const wasOrphan = userCompanyGroup.userGroupId === null;
        userCompanyGroup.userGroupId = result.id;
        this.permissionService.moveUserToAnotherUserGroup(userCompanyGroup).toPromise().then( () => {
          if(wasOrphan) {
            const orphanIndex = this.orphans.findIndex(user => user.id === this.user.id);
            this.orphans.splice(orphanIndex, 1);
          } else {
            // find the old userGroup and remove the user from this group
            const userGroupIndexOld = this.groups.findIndex(elem => elem.users.includes(this.user))
            this.groups[userGroupIndexOld].users = this.groups[userGroupIndexOld].users.filter(user => user.id !== this.user.id);
          }
          // find the new userGroup and push the user into this group
          const userGroupIndexNew = this.groups.findIndex(elem => elem.userGroup.id === result.id);
          this.groups[userGroupIndexNew].users.push(this.user);
        }).catch( error => {
          Sentry.captureException(error)
          console.log(error);
        });
      }
    })
  }

  ngOnDestroy(): void { }
}
